var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "discrete-query-page", attrs: { fluid: "" } },
    [
      _c("MissingParamsDialog", {
        ref: "missingParamsDialog",
        on: {
          mustSaveMissingParams: function ($event) {
            _vm.mustSaveMissingParams = true
          },
        },
      }),
      _vm._v(" "),
      _c("header", { staticClass: "query-page-header" }, [
        _c("div", { staticClass: "query-page-copy" }, [
          _c("div", { staticClass: "query-page-eyebrow" }, [
            _vm._v("Discrete data query"),
          ]),
          _vm._v(" "),
          _c("h1", [_vm._v("Build a data extract")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Set the data scope, choose analytes and the reporting period, optionally add guidelines, then review the complete selection before downloading."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "query-page-actions" },
          [
            _c(
              "v-btn",
              {
                staticClass: "my-2",
                on: {
                  click: function ($event) {
                    _vm.drawer = true
                  },
                },
              },
              [
                _c("v-icon", { attrs: { left: "", color: "info" } }, [
                  _vm._v("folder_open"),
                ]),
                _vm._v("\n        Load saved query\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c("NewQuery", {
              attrs: {
                confirmOnNew: _vm.hasUnsavedChanges,
                disabled: !_vm.canNewQuery,
              },
              on: {
                "clear:query": function ($event) {
                  return _vm.clearQuery()
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "query-workspace" },
        [
          _c(
            "v-layout",
            [
              _c("SavedQueries", {
                ref: "savedQueries",
                attrs: {
                  confirmOnLoad: _vm.hasUnsavedChanges,
                  query: _vm.query,
                  drawer: _vm.drawer,
                },
                on: {
                  "update:drawer": function ($event) {
                    _vm.drawer = $event
                  },
                  "load:query": function ($event) {
                    return _vm.loadQuery($event)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "pt-0", staticStyle: { "min-width": "0" } },
                [
                  _c(
                    "div",
                    { staticClass: "query-summary" },
                    [
                      _c("div", { staticClass: "query-summary-copy" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.query ? _vm.query.name : "New query")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.queryStatusText))]),
                      ]),
                      _vm._v(" "),
                      _c("SaveQuery", {
                        attrs: {
                          buttonLabel: "Save as new",
                          query: _vm.query,
                          disabled: !_vm.canSave,
                          selection: _vm.selection,
                          reportOptions: _vm.reportOptions,
                        },
                        on: {
                          "update:query": function ($event) {
                            return _vm.updateQuery($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("AlertsBar", {
                    staticClass: "pb-1",
                    attrs: {
                      wizardMode: true,
                      mustSaveMissingParams: _vm.mustSaveMissingParams,
                      hasSelectedStation: _vm.hasSelectedStation,
                      hasSelectedAnalyte: _vm.hasSelectedAnalyte,
                      hasMadeSelection: _vm.hasMadeSelection,
                      isQuerySaved: _vm.isQuerySaved,
                      hasQuery: !!_vm.query,
                      hasUnsavedChanges: _vm.hasUnsavedChanges,
                    },
                    on: {
                      showMissingParams: function ($event) {
                        return _vm.$refs.missingParamsDialog.show()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("v-progress-linear", {
                        staticClass: "my-0",
                        attrs: { height: 4, color: "info", indeterminate: "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("DiscreteQueryWizard", {
                    ref: "queryWizard",
                    attrs: {
                      isGeneratingReport:
                        _vm.isGeneratingReport ||
                        _vm.isSubmittingAsyncGeneratingRequest,
                    },
                    on: {
                      "update:isInitialized": function ($event) {
                        _vm.isInitialized = $event
                      },
                      "update:loading": _vm.updateLoadingState,
                      "update:selection": _vm.updateSelection,
                      "update:reportOptions": _vm.updateReportOptions,
                      "update:allMediaTypes": function ($event) {
                        _vm.allMediaTypes = $event
                      },
                      "update:canSubmit": function ($event) {
                        _vm.queryReady = $event
                      },
                      "update:dirty": function ($event) {
                        _vm.wizardDirty = $event
                      },
                      "update:downloadLoading": function ($event) {
                        _vm.isSubmittingAsyncGeneratingRequest = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }